import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { House, Files, Sparkles, User, ChevronLeft } from "lucide-react";

const NAV = [
  { key: "home", label: "Home", icon: House, path: "/home" },
  { key: "documents", label: "Documents", icon: Files, path: "/documents" },
  { key: "kai", label: "Kai", icon: Sparkles, path: "/kai" },
  { key: "account", label: "Account", icon: User, path: "/account" },
];

export const BottomNav = ({ floating = true }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <nav
      data-testid="bottom-nav"
      className={`${floating ? "fixed bottom-0 left-1/2 -translate-x-1/2" : "relative shrink-0"} w-full max-w-md h-[76px] bg-surface border-t border-border flex justify-around items-center px-2 z-50`}
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      {NAV.map((n) => {
        const active = pathname === n.path || pathname.startsWith(n.path + "/");
        const Icon = n.icon;
        return (
          <button
            key={n.key}
            data-testid={`nav-${n.key}`}
            onClick={() => navigate(n.path)}
            className="flex flex-col items-center gap-1 flex-1 py-2 group"
          >
            <Icon size={24} strokeWidth={active ? 2.5 : 2} className={active ? "text-brandPrimary transition-colors" : "text-muted-foreground group-active:scale-90 transition-transform"} fill={active ? "#FFEDD5" : "none"} />
            <span className={`text-[11px] font-semibold ${active ? "text-brandPrimary" : "text-muted-foreground"}`}>{n.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export const Shell = ({ children, title, subtitle, showNav = true, back = false, right = null, className = "" }) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-surfaceSecondary flex justify-center">
      <div className="w-full max-w-md bg-surfaceSecondary min-h-screen relative" style={{ paddingBottom: showNav ? 96 : 24 }}>
        {(title || back) && (
          <header className="sticky top-0 z-40 bg-surface/90 backdrop-blur-md border-b border-border px-4 h-16 flex items-center gap-3">
            {back && (
              <button data-testid="header-back" onClick={() => navigate(-1)} className="w-9 h-9 -ml-1 rounded-full flex items-center justify-center hover:bg-surfaceTertiary transition-colors">
                <ChevronLeft size={22} className="text-onSurface" />
              </button>
            )}
            <div className="flex-1 min-w-0">
              {title && <h1 className="font-heading text-lg font-bold text-onSurface truncate">{title}</h1>}
              {subtitle && <p className="text-xs text-muted-foreground truncate">{subtitle}</p>}
            </div>
            {right}
          </header>
        )}
        <main className={`px-4 pt-4 ${className}`}>{children}</main>
        {showNav && <BottomNav />}
      </div>
    </div>
  );
};
